import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'totalPrice',
    standalone: false
})
export class TotalPricePipe implements PipeTransform {
  transform(totalPrice: number, vat: number, discount: number, discountEnabled: boolean): number {
    if (vat > 0) {
      totalPrice = Number(totalPrice) + (Number(totalPrice) * Number(vat));
    }

    if (discount > 0 && discountEnabled) {
      return totalPrice - (totalPrice * ( discount / 100));
    }

    return totalPrice;
  }
}
